 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLPRAISE from '@/components/xhtml/praise'
 import XHTMLSS_US_ADULT_SIGNUP_FRONT from '@/components/xhtml/SS_US_adult_signup_front'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCONT from '@/components/xhtml/cont'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLFM01 from '@/components/xhtml/fm01'
 import XHTMLEPIGRAPH from '@/components/xhtml/epigraph'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLCH15A from '@/components/xhtml/ch15a'
 import XHTMLCH15B from '@/components/xhtml/ch15b'
 import XHTMLCH16 from '@/components/xhtml/ch16'
 import XHTMLCH17 from '@/components/xhtml/ch17'
 import XHTMLCH18 from '@/components/xhtml/ch18'
 import XHTMLCH19 from '@/components/xhtml/ch19'
 import XHTMLCH20 from '@/components/xhtml/ch20'
 import XHTMLCH21 from '@/components/xhtml/ch21'
 import XHTMLCH22 from '@/components/xhtml/ch22'
 import XHTMLCH23 from '@/components/xhtml/ch23'
 import XHTMLCH24 from '@/components/xhtml/ch24'
 import XHTMLCH25 from '@/components/xhtml/ch25'
 import XHTMLCH26 from '@/components/xhtml/ch26'
 import XHTMLCH27 from '@/components/xhtml/ch27'
 import XHTMLCH28 from '@/components/xhtml/ch28'
 import XHTMLCH29 from '@/components/xhtml/ch29'
 import XHTMLCH30 from '@/components/xhtml/ch30'
 import XHTMLCH31 from '@/components/xhtml/ch31'
 import XHTMLCH32 from '@/components/xhtml/ch32'
 import XHTMLCH33 from '@/components/xhtml/ch33'
 import XHTMLCH34 from '@/components/xhtml/ch34'
 import XHTMLCH35 from '@/components/xhtml/ch35'
 import XHTMLCH36 from '@/components/xhtml/ch36'
 import XHTMLCH37 from '@/components/xhtml/ch37'
 import XHTMLEPILOGUE from '@/components/xhtml/epilogue'
 import XHTMLPHOTOGRAPHS from '@/components/xhtml/photographs'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLSS_RECOMMENDPAGE from '@/components/xhtml/SS_recommendpage'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLADCARD from '@/components/xhtml/adcard'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLSS_US_ADULT_SIGNUP_BACK from '@/components/xhtml/SS_US_adult_signup_back'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/bibliography'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLCOPY from '@/components/xhtml/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cont",
 			"name" : "xhtml/cont",
 			"component" : XHTMLCONT
 		},
 		{
 			"path" : "/xhtml/dedication",
 			"name" : "xhtml/dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/fm01",
 			"name" : "xhtml/fm01",
 			"component" : XHTMLFM01
 		},
 		{
 			"path" : "/xhtml/epigraph",
 			"name" : "xhtml/epigraph",
 			"component" : XHTMLEPIGRAPH
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
 		{
 			"path" : "/xhtml/ch03",
 			"name" : "xhtml/ch03",
 			"component" : XHTMLCH03
 		},
 		{
 			"path" : "/xhtml/ch04",
 			"name" : "xhtml/ch04",
 			"component" : XHTMLCH04
 		},
 		{
 			"path" : "/xhtml/ch05",
 			"name" : "xhtml/ch05",
 			"component" : XHTMLCH05
 		},
 		{
 			"path" : "/xhtml/ch06",
 			"name" : "xhtml/ch06",
 			"component" : XHTMLCH06
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js